// replay-common.ts — small helpers shared by both replay viewers (2D and 3D).
import type { ParsedReplay } from '../../../workers/multiplayer/src/replay.ts';

// escape untrusted text (player names from the .wirep header, archive keys) before it reaches
// innerHTML — recording headers are attacker-authorable (?wirep=<url> loads arbitrary files)
export function escapeHtml(t: string): string {
  return t
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// The facts both viewers derive from a parsed recording. This trio IS the determinism contract —
// rosterFor feeds the fog re-sim (a different `local` side re-simulates bit-exactly because fog
// reveal is unhashed) and hashByBlock drives checkpoint validation — so it lives in one place.
export function replayDerived(rep: ParsedReplay): {
  rosterFor: (
    side: number,
  ) => { pid: number; side: number; name: string; flags: number; local: boolean }[];
  lastBlock: number;
  hashByBlock: Map<number, number>;
} {
  const rosterFor = (side: number) =>
    rep.header.roster.map((r) => ({
      pid: r.pid,
      side: r.side,
      name: r.name,
      flags: r.flags,
      local: r.side === side,
    }));
  const lastBlock = rep.blocks.length ? rep.blocks[rep.blocks.length - 1].block : 0;
  const hashByBlock = new Map<number, number>();
  for (const b of rep.blocks) if (b.syncHash) hashByBlock.set(b.block, b.syncHash >>> 0);
  return { rosterFor, lastBlock, hashByBlock };
}
